import { render } from "./ReportFilter.vue?vue&type=template&id=5c666a4f&bindings={}"
import script from "./ReportFilter.vue?vue&type=script&lang=ts"
export * from "./ReportFilter.vue?vue&type=script&lang=ts"
script.render = render

export default script